import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { datePickerDriverFactory } from './DatePicker.driver';
import { DatePicker } from '.';

describe('DatePicker', () => {
  const createDriver = createRendererWithUniDriver(datePickerDriverFactory);

  const bootstrap = (props = {}) => {
    const dataHook = 'compDataHook';
    const compProps = {
      'data-hook': dataHook,
      onChange: () => {},
      ...props,
    };
    return createDriver(<DatePicker {...compProps} />);
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });

  it('should display the correct selected date', async () => {
    const date = new Date(2019, 11, 15);
    const { driver } = bootstrap({ value: date });

    expect(await driver.getSelectedDay()).toBe('15');
    expect(await driver.getCurrentMonthWithYear()).toBe('December 2019');
  });

  it('should call onChange with the clicked day', async () => {
    const onChange = jest.fn();
    const date = new Date(2019, 11, 15);
    const { driver } = bootstrap({ value: date, onChange });

    expect(onChange).toHaveBeenCalledTimes(0);

    await driver.clickDay(new Date(2019, 11, 16));

    expect(onChange).toHaveBeenCalledTimes(1);
    expect(onChange.mock.calls[0][0].getDate()).toEqual(16);
  });

  it('should call onChange with the selected day even if it is already selected', async () => {
    const onChange = jest.fn();
    const date = new Date(2019, 11, 15);
    const { driver } = bootstrap({ value: date, onChange });

    expect(onChange).toHaveBeenCalledTimes(0);

    await driver.clickDay(date);

    expect(onChange).toHaveBeenCalledTimes(1);
    expect(onChange.mock.calls[0][0].getDate()).toEqual(15);
  });

  it('should call onMonthChange with the first date of the month', async () => {
    const currentMonth = 2;
    const date = new Date(2021, currentMonth, 1);
    const expectedMonth = new Date(2021, currentMonth + 1, 1);
    const onMonthChange = jest.fn();

    const { driver } = bootstrap({ value: date, onMonthChange });

    expect(onMonthChange).toHaveBeenCalledTimes(0);

    await driver.clickOnNextMonthButton();

    expect(onMonthChange).toHaveBeenCalledTimes(1);
    const onMonthChangeValue = onMonthChange.mock.calls[0][0];
    expect(onMonthChangeValue.toLocaleDateString()).toEqual(
      expectedMonth.toLocaleDateString(),
    );
  });

  it('should keep focus after selection', async () => {
    const date = new Date(2021, 2, 1);
    const { driver, container } = bootstrap({ value: date });

    const nextBtn = container.querySelector(
      '[data-hook="datepicker-right-arrow"]',
    ) as HTMLElement | null;

    expect(nextBtn).not.toBeNull();
    nextBtn!.focus();
    expect(document.activeElement).toBe(nextBtn);

    await driver.clickOnNextMonthButton();

    expect(document.activeElement).toBe(nextBtn);
  });
});
